<template>
  <div class="info-con" v-loading="loading">
    <h2 class="tl-title" v-if="name !== ''">{{ name }}</h2>
    <div class="tl-con" v-if="list.length">
      <waterfall :col="6" :data="list" width="200" :gutterWidth="5" lazyDistance="100">
        <div class="pr pbImgBox" v-for="(item,index) in list" :key="index">
          <el-popover placement="right" trigger="hover" popper-class="popover">
            <div class="popimg" style="background:#fff;">
              <ul style="border-bottom:1px solid #F0EEF3;">
                <li style="width:122px;">下载人</li>
                <li>下载时间</li>
              </ul>
              <ul>
                <li style="width:122px;">{{item.username}}</li>
                <li>{{item.created_at}}</li>
              </ul>
            </div>
            <div slot="reference">
              <el-image :style="item.style" :src="issafariBrowser?item.img:item.thumbnail_img" :data-attr="item.img" />
            </div>
          </el-popover>
        </div>
      </waterfall>

      <Pagination v-if="Pagination.total > Pagination.page_size" @handleCurrentChange="handleCurrentChange"
        :Pagination="Pagination" />
    </div>
    <no-content v-else class="tl-con tl-cen" />
  </div>
</template>

<script>
  import {
    Statistics
  } from "@/config/axios/new_api";
  import noContent from "@/components/common/noContent.vue";
  import Index from "@/config/mixin/index.js";
  export default {
    components: {
      noContent
    },
    mixins: [Index],
    data() {
      return {
        issafariBrowser: '',
        list: [{}],
        name: "",
        loading: false,
        num: 1,
        Pagination: {
          total: 0,
          page: 1,
          page_size: 25,
        },
      };
    },
    created() {

    },
    mounted() {
      this.issafariBrowser = /Safari/.test(navigator.userAgent) && !/Chrome/.test(navigator.userAgent);
      this.Pagination.page = this.$route.query.page;
      this.num = this.$route.query.num;
      this.getData();
    },
    methods: {
      getData(status = false) {
        if (this.num == 1) {
          let data = {
            team_id: this.$route.query.team_id,
            uid: this.$route.query.userid,
            page: this.Pagination.page,
            pagesize: this.Pagination.page_size,
            start_time: this.$route.query.startTime,
            end_time: this.$route.query.endTime
          };
          Statistics.statistics_enterprise_design_download_all(data).then((res) => {
            if (status) {
              this.$waterfall.forceUpdate();
            }
            this.$nextTick(() => {
              this.loading = false;
              var issafariBrowser =
                /Safari/.test(navigator.userAgent) &&
                !/Chrome/.test(navigator.userAgent);
              this.list = res.data.data.map((item) => {
                item.username = item.user.nick_name
                let [width, height] = item.team_template.size.split("x");
                let newWidth = 0,
                  newHeight = 0;
                if (width / 6 !== 180) {
                  newHeight = (180 / width) * height;
                  newWidth = 180;
                } else {
                  newWidth = 180;
                  newHeight = (180 / width) * height;
                }
                item.style = {
                  width: "180px",
                  height: "auto",
                  background: "#000",
                };
                return item;
              });
              this.Pagination.total = res.data.total;
            });
          });
        } else {
          let data = {
            team_id: this.$route.query.team_id,
            team_template_id: this.$route.query.userid,
            page: this.Pagination.page,
            pagesize: this.Pagination.page_size,
            start_time: this.$route.query.startTime,
            end_time: this.$route.query.endTime
          };
          Statistics.statistics_enterprise_design_download_all(data).then((res) => {
            if (status) {
              this.$waterfall.forceUpdate();
            }
            this.$nextTick(() => {
              this.loading = false;
              var issafariBrowser =
                /Safari/.test(navigator.userAgent) &&
                !/Chrome/.test(navigator.userAgent);
                if(!res.data) {
                  this.list = [];
                  this.Pagination.total = 0;
                  return 
                };
              this.Pagination.total = res.data.total;

              this.list = res.data.data.map((item) => {
                item.username = item.user.nick_name
                let [width, height] = item.team_template.size.split("x");
                let newWidth = 0,
                  newHeight = 0;
                if (width / 6 !== 180) {
                  newHeight = (180 / width) * height;
                  newWidth = 180;
                } else {
                  newWidth = 180;
                  newHeight = (180 / width) * height;
                }
                item.style = {
                  width: "180px",
                  height: "auto",
                  background: "#000",
                };
                return item;
              });
            });
          });
        }
      },
      // 分页查询
      handleCurrentChange(val = 1) {
        this.Pagination.page = val;
        this.getData(true);
      },
    },
  };
</script>

<style lang="scss" scoped>
  .tl-title {
    margin: 80px 0 0;
    color: #3c3c43;
    line-height: 33px;
    font-size: 24px;
    text-align: center;
  }

  .pbImgBox {
    cursor: pointer;
    padding: 10px;
    transition: all 0.3s;

    &:hover {
      background: #f3f3f3;
      border-radius: 8px;

      .text-title {
        display: block;
      }

      // > div {
      //   padding: 10px;
      // }
    }

    >div {
      width: 180px;
    }

    img {
      width: 100%;
      height: auto;
    }

    .text-title {
      height: 34px;
      padding: 2px 10px 0;
      color: #3b3946;
      display: none;
    }
  }

  .tl-con {
    width: 1260px;
    height: 500px;
    margin: 60px auto 0;
  }

  .tl-cen {
    position: absolute;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);
  }

  ::v-deep(.vue-waterfall.is-transition img) {
    opacity: 1;
  }

  .popimg {
    padding: 0 24px;
    width: 418px;
    color: #3B3946;
    font-size: 14px;

    ul {
      display: flex;

      li {
        padding: 14px 16px;
      }
    }
  }
</style>
<style lang="scss">
  .popover {
    padding: 0;

    .popper__arrow {
      display: none;
    }
  }
</style>